module.exports = __webpack_public_path__ + "static/img/physical_harm_1.e1713da8.png";